/**
 * 🎮 EXPERIENCIAS VR
 * Todas las experiencias de realidad virtual disponibles
 */

export const experiences = {
  "threat-lethal": {
    id: "threat-lethal",
    title: "THREAT LETHAL",
    slug: "threat-lethal",
    subtitle: "MISIÓN TÁCTICA",
    // Nuevos: imagen para carrusel, video y descripción serializable
    carouselImage:
      "/images/Desktop/Experiencias/ThreatLethal/ThreatLethal-Banner.webp",
    video:
      "https://videos.ctfassets.net/adsfyhieuvzo/4VSRqiDBwd8G5GNXTMZKiV/f357168d123ea1a7b625bc931228377f/Threat_Lethal_Square1.mp4",
    mediaDescription: {
      paragraphs: [
        "¿Está tu equipo equipado para detener Threat Lethal?",
        "Este revolucionario modo de equipo transforma Space Marine VR: Defenders of Avarax en nuestra experiencia más desafiante hasta la fecha. Únete a la batalla, demuestra tu valentía y domina el trabajo en equipo en esta nueva y electrizante misión.",
      ],
      bullets: [
        "Una aventura trepidante",
        "Jugadores 1-8",
        "Supervivencia Cooperativa",
        "30 a 45 min",
      ],
    },
    description:
      "Participa en una misión táctica de alto riesgo donde cada decisión cuenta.",
    image:
      "https://images.ctfassets.net/adsfyhieuvzo/L9dEDSKvfYWvQVhUGTLkq/d8b9e71e0b5e9cb0487a1e63be008998/ZeroLatency_SOL_RAIDERS_TACTICIAN_Character_Experience_tile_350x469_D.jpg?w=469&h=350&fm=webp",
    imageAlt: "Experiencia Threat Lethal VR",
    duration: "30 Min - 45 Min",
    players: "1-8 jugadores",
    difficulty: "Avanzado",
    ages: "13+",
    category: "SHOOTER EN EQUIPO DE CIENCIA FICCIÓN",
    features: ["1-8 jugadores", "35 min", "13+"],
    tags: ["Táctica", "Combate", "Estrategia"],
    badge: "NUEVO",
    cta: {
      text: "Aceptar Misión",
      variant: "primary-orange",
      size: "large",
      href: "/experiencias/threat-lethal",
      animation: "pulse",
    },
  },
  "space-marine": {
    id: "space-marine",
    title: "SPACE MARINE VR",
    slug: "space-marine",
    subtitle: "BATALLA ÉPICA",
    carouselImage:
      "/images/Desktop/Experiencias/SpaceMarine/SpaceMarine-CarouselCard.webp",
    video:
      "https://videos.ctfassets.net/adsfyhieuvzo/3b1SKQnzWs0VQjMpZsNG2j/34f8ae0a1afe06f811ec947008667bb6/Warhammer-40000-Space-Marine-VR-Teaser-Tyranid-Action-720-Crop.mp4",
    mediaDescription: {
      paragraphs: [
        "¿Está tu escuadrón preparado para desafiar Threat: Lethal?",
        "Un modo de equipo tan intenso que pondrá a prueba tu verdadero valor. Este revolucionario modo de equipo transforma Space Marine VR: Defenders of Avarax en nuestra experiencia más desafiante hasta la fecha.",
      ],
      bullets: [
        "Una aventura trepidante",
        "Jugadores 1-8",
        "Supervivencia Cooperativa",
        "30 a 45 min",
      ],
    },
    description:
      "Únete a las fuerzas espaciales en esta batalla épica contra aliens hostiles.",
    image:
      "https://images.ctfassets.net/adsfyhieuvzo/vNhKQcTd8TKgdDs01SiyU/d9307ff6696bb7b6c5fb9067d0ee29fa/Space-Marine-Game-Experience-Threat-Lethal-Tile.jpg?w=469&h=350&fm=webp",
    imageAlt: "Experiencia Space Marine VR",
    duration: "30 min",
    players: "1-8",
    difficulty: "Avanzado",
    category: "SHOOTER SCI-FI",
    ages: "Varía según el local",
    features: ["1-8 jugadores", "30 min", "+18"],
    tags: ["Sci-Fi", "Combate", "Estrategia"],
    cta: {
      text: "Unirse a Space Marine",
      variant: "primary-blue",
      size: "large",
      href: "/experiencias/space-marine",
      animation: "scale",
    },
  },
  "far-cry": {
    id: "far-cry",
    title: "FARCRY VR",
    slug: "far-cry",
    subtitle: "AVENTURA TROPICAL",
    carouselImage:
      "/images/Desktop/Experiencias/FarCry/FarCry-CarouselCard.jpg",
    video:
      "https://videos.ctfassets.net/adsfyhieuvzo/kzHIuzugluGVffgvmDEjv/9212fe1f89ef27c8c7aec0aff7ae9f54/Tab-Image-Text-Far-Cry_d_720x600.mp4",
    mediaDescription: {
      paragraphs: [
        "Sumérgete en la aterradora realidad de un apocalipsis zombie.",
        "Tú y tu equipo son los últimos salvadores de la única cura para la humanidad. Desata tu furia o sucumbe al miedo mientras te enfrentas a hordas de zombies hambrientos en tu misión a través de un hospital abandonado.",
      ],
      bullets: [
        "Una experiencia que te pondrá el corazón a mil",
        "1-8 Jugadores",
        "Aventura cooperativa",
        "30 min aprox.",
      ],
    },
    description:
      "Explora una isla tropical llena de peligros y aventuras en este emocionante juego de supervivencia.",
    image:
      "https://images.ctfassets.net/adsfyhieuvzo/21N1yC0dYFsPE8wdFfcW7V/74e1edfc9f765e3439f0ed8cc97cd20a/ZeroLatency_FAR_CRY_SURVIVOR_Character_Experience_tile_350x469_D.jpg?w=469&h=350&fm=webp",
    imageAlt: "Experiencia Far Cry VR",
    duration: "30 min",
    players: "1-8",
    difficulty: "Intermedio",
    category: "Shooter Cooperativo",
    ages: "Varía según local",
    features: ["4 jugadores", "25 min", "+18"],
    tags: ["Acción", "Aventura", "Tropical"],
    badge: "TENDENCIA",
    cta: {
      text: "Explorar Far Cry",
      variant: "primary-orange",
      size: "large",
      href: "/experiencias/far-cry",
      animation: "scale",
    },
  },
  outbreak: {
    id: "outbreak",
    title: "OUTBREAK",
    slug: "outbreak",
    subtitle: "SUPERVIVENCIA ZOMBIE",
    carouselImage:
      "/images/Desktop/Experiencias/Outbreak/Outbreak-CarouselCard.webp",
    video:
      "https://videos.ctfassets.net/adsfyhieuvzo/4P5Qb9KEZG7yA6UoH0ONYD/2e8a737b8c47fe3c18cd0113af3e60ce/Tab-Image-Text-Outbreak_d_720x600.mp4",
    mediaDescription: {
      paragraphs: [
        "Sumérgete en la aterradora realidad de un apocalipsis zombie.",
        "Tú y tu equipo son los últimos salvadores de la única cura para la humanidad. Desata tu furia o sucumbe al miedo mientras te enfrentas a hordas de zombies hambrientos en tu misión a través de un hospital abandonado y un sótano pantanoso.",
      ],
      bullets: [
        "Una experiencia que te pondrá el corazón a mil",
        "1-8 Jugadores",
        "Aventura cooperativa",
        "30 min aprox.",
      ],
    },
    description:
      "Sobrevive al apocalipsis zombie en esta intensa experiencia de supervivencia.",
    image:
      "https://images.ctfassets.net/adsfyhieuvzo/50TkzwCqYcnD3rclElHCWh/14899394cd4cdb8eede543e93b4cce99/ZeroLatency_OUTBREAK_SURVIVOR_Character_Experience_tile_350x469_D.jpg?w=469&h=350&fm=webp",
    imageAlt: "Experiencia Outbreak VR",
    duration: "30 min",
    players: "1-8",
    difficulty: "INTENSO",
    category: "SHOOTER COOPERATIVO",
    ages: "Según la sede",
    features: ["1-8 JUGADORES", "30 min", "Según la sede"],
    tags: ["Acción", "Zombies", "Supervivencia"],
    badge: "INTENSO",
    cta: {
      text: "Sobrevivir Outbreak",
      variant: "primary-orange",
      size: "large",
      href: "/experiencias/outbreak",
      animation: "pulse",
    },
  },
  singularity: {
    id: "singularity",
    title: "SINGULARITY",
    slug: "singularity",
    subtitle: "CIENCIA FICCIÓN",
    carouselImage:
      "https://images.ctfassets.net/adsfyhieuvzo/3xyMVrDFqGrLOxU8sVCfeS/bfc3609bfd99b0e68b02908f9345f697/Singularity_Desktop-base_255x143.44.jpg?w=290&h=175&fm=webp",
    video:
      "https://videos.ctfassets.net/adsfyhieuvzo/2QOD7jg1oCpFHg9ruTykHr/3e3b42a140b179a7bcb564877ee80408/Tab-Image-Text-Singularity_d_720x600.mp4",
    mediaDescription: {
      paragraphs: [
        "Viaja en el tiempo para salvar el futuro.",
        "Una experiencia de ciencia ficción donde debes manipular el tiempo y el espacio para resolver puzzles complejos y salvar la humanidad de un destino oscuro.",
      ],
      bullets: [
        "Puzzles de viaje en el tiempo",
        "Jugadores: 1-6",
        "Duración: 40-50 min",
        "Edad mínima: 12",
      ],
    },
    description:
      "Explora un futuro distópico donde la tecnología y la humanidad chocan.",
    image:
      "https://images.ctfassets.net/adsfyhieuvzo/2067c5FkQDiLWTipISbwlb/6af96ee4a6d30dda45f07a11ccbbaa4b/ZeroLatency_SINGULARITY_COMPETITOR_Character_Experience_tile_350x469_D.jpg?w=469&h=350&fm=webp",
    imageAlt: "Experiencia Singularity VR",
    duration: "30 min",
    players: "1-8",
    difficulty: "Avanzado",
    category: "Shooter Cooperativo",
    ages: "Varía según sede",
    features: ["4 jugadores", "25 min", "+18"],
    tags: ["Sci-Fi", "Combate", "Estrategia"],
    cta: {
      text: "Explorar Singularity",
      variant: "secondary",
      size: "large",
      href: "/experiencias/singularity",
      animation: "glow",
    },
  },
  "undead-arena": {
    id: "undead-arena",
    title: "UNDEAD ARENA",
    slug: "undead-arena",
    subtitle: "ARENA DE COMBATE",
    carouselImage:
      "https://images.ctfassets.net/adsfyhieuvzo/4CmleloyyseEyFTR2Hsh34/7dd580e1dc68cf01791cf2847f50d6f6/Undead-Arena_Desktop-base_255x143.44.jpg?w=290&h=175&fm=webp",
    video:
      "https://videos.ctfassets.net/adsfyhieuvzo/3uZ8f0GFtz5B65mA8CSSNe/9000e32f185dbd4ff9e58357b2575d40/Tab-Image-Text-Undead-Arena_d_720x600.mp4",
    mediaDescription: {
      paragraphs: [
        "Sumérgete en la aterradora realidad de un apocalipsis zombie.",
        "Tú y tu equipo son los últimos salvadores de la única cura para la humanidad. Desata tu furia o sucumbe al miedo mientras te enfrentas a hordas de zombies hambrientos en tu misión a través de un hospital abandonado.",
      ],
      bullets: [
        "Una experiencia que te pondrá el corazón a mil",
        "1-8 Jugadores",
        "Aventura cooperativa",
        "30 min aprox.",
      ],
    },
    description:
      "Enfréntate a hordas de no-muertos en esta intensa arena de combate.",
    image:
      "https://images.ctfassets.net/adsfyhieuvzo/5y5METWcAEx270jWI4FNVs/e3f71c00bea51548a0455fb3efb28014/ZeroLatency_UNDEAD_ARENA_SCARED_Character_Experience_tile_350x469_D.jpg?w=469&h=350&fm=webp",
    imageAlt: "Experiencia Undead Arena VR",
    duration: "15 min",
    players: "1-8",
    difficulty: "Avanzado",
    category: "Shooter de Combate",
    ages: "Varía según local",
    features: ["4 jugadores", "15 min", "+18"],
    tags: ["Acción", "Combate", "Arena"],
    cta: {
      text: "Entrar a la Arena",
      variant: "primary-blue",
      size: "large",
      href: "/experiencias/undead-arena",
      animation: "pulse",
    },
  },
  "sol-raiders": {
    id: "sol-raiders",
    title: "SOL RAIDERS",
    slug: "sol-raiders",
    subtitle: "AVENTURA ESPACIAL",
    carouselImage:
      "/images/Desktop/Experiencias/SolRaiders/SolRaiders-CarouselCard.webp",
    video:
      "https://videos.ctfassets.net/adsfyhieuvzo/5EzIQKaMvdGuUU4oecWO5D/ce5a719eaaa66a58240cc51a7fe0f17d/Tab-Image-Text-Sol-Raiders_d_720x600.mp4",
    mediaDescription: {
      paragraphs: [
        "Aventura espacial épica entre las estrellas.",
        "Explora galaxias lejanas, combate piratas espaciales y descubre tesoros ocultos en esta aventura de ciencia ficción que te llevará a los confines del universo.",
      ],
      bullets: [
        "Exploración espacial",
        "Jugadores: 2-6",
        "Duración: 45-55 min",
        "Edad mínima: 10",
      ],
    },
    description:
      "Únete a los Sol Raiders en una épica aventura espacial llena de acción y estrategia.",
    image:
      "https://images.ctfassets.net/adsfyhieuvzo/L9dEDSKvfYWvQVhUGTLkq/d8b9e710e0b5e9cb0487a1e63be008998/ZeroLatency_SOL_RAIDERS_TACTICIAN_Character_Experience_tile_350x469_D.jpg?w=469&h=350&fm=webp",
    imageAlt: "Experiencia Sol Raiders VR",
    duration: "15 min",
    players: "1-8",
    difficulty: "Intermedio",
    ages: "Varía según la sede",
    category: "Shooter jugador contra jugador",
    features: ["4 jugadores", "25 min", "+16"],
    tags: ["Sci-Fi", "Combate", "Estrategia"],
    cta: {
      text: "Unirse a Sol Raiders",
      variant: "location",
      size: "large",
      href: "/experiencias/sol-raiders",
      animation: "ripple",
    },
  },
  engineerium: {
    id: "engineerium",
    title: "ENGINEERIUM",
    slug: "engineerium",
    subtitle: "AVENTURA COOPERATIVA",
    carouselImage:
      "https://images.ctfassets.net/adsfyhieuvzo/WfXbTcbR88DXz93rMuaxb/b7cb7fcae4ba0866f232eaf47b050d9a/Engineerium_Desktop-base_255x143.44.jpg?w=290&h=175&fm=webp",
    video:
      "https://videos.ctfassets.net/adsfyhieuvzo/jvydfsIgZUrHbuAkvYIEX/ac809df277136185c5118adc08dae6dd/Tab-Image-Text-Enineerium_d_720x600.mp4",
    mediaDescription: {
      paragraphs: [
        "Resuelve puzzles en un mundo steampunk mágico.",
        "Usa tu ingenio para resolver complejos puzzles mecánicos y restaurar una máquina gigante en este mundo de vapor y engranajes. Perfecto para familias y grupos.",
      ],
      bullets: [
        "Puzzles mecánicos complejos",
        "Jugadores: 2-4",
        "Duración: 30-40 min",
        "Edad mínima: 12",
      ],
    },
    description:
      "Resuelve puzzles complejos y trabaja en equipo en esta experiencia que desafiará tu mente.",
    image:
      "https://images.ctfassets.net/adsfyhieuvzo/5iOLdoRphZGVXCnJkUC0vk/4d3dd48610f44c30324e644a4121c886/ZeroLatency_ENGINEERIUM_EXPLORER_Character_Experience_tile_350x469_D.jpg?w=469&h=350&fm=webp",
    imageAlt: "Experiencia Engineerium VR",
    duration: "15 min",
    players: "1-8",
    difficulty: "Fácil",
    category: "AVENTURA COOPERATIVA",
    ages: "Varía según sede",
    features: ["1-8 jugadores", "15 min"],
    tags: ["Cooperativo", "AVENTURA", "Familia"],
    badge: "POPULAR",
    cta: {
      text: "Explorar Engineerium",
      variant: "secondary",
      size: "large",
      href: "/experiencias/engineerium",
      animation: "glow",
    },
  },
};
